import React from 'react';
import { Container, Typography } from 'amphitheatre';

import BusinessPlans from './BusinessPlans';
import Overpass from './Overpass';
import PIGIDownload from './PIGIDownload';

const { Header, Paragraph } = Typography;

function Home(): React.ReactElement {
  return (
    <Container size="lg">
      <Header level={2}>Downloads</Header>
      <Paragraph>
        Latest files that you need to compete in <i>Quest For Blue</i>
      </Paragraph>
      <PIGIDownload />
      <BusinessPlans />
      <Overpass />
    </Container>
  );
}

export default Home;
